import React from "react";

import { MarketingConfigurationModule } from "../../../modules/MarketingConfiguration";
import DashboardLayout from "../../../molecules/DashboardLayout";

const MarketingConfiguration = () => {
  return (
    <DashboardLayout>
      <MarketingConfigurationModule />
    </DashboardLayout>
  );
};

export default MarketingConfiguration;
